import { render } from "./PlacesList.vue?vue&type=template&id=feeec840&scoped=true"
import script from "./PlacesList.vue?vue&type=script&lang=js"
export * from "./PlacesList.vue?vue&type=script&lang=js"

import "./PlacesList.vue?vue&type=style&index=0&id=feeec840&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feeec840"]])

export default __exports__